import getAllDetails from 'core/services/getAllDetails'
import getActiveApplications from 'core/services/getActiveApplications'
import { DENTAL } from 'core/constants/products'
import store from 'utils/store/withMiddleware'

function getAdditionalInfo(state): Promise<Pivot.State> {
  return Promise.all([getAllDetails(), getActiveApplications(state.hcStorage)]).then(
    data => {
      const [
        [dentalStandard = {}, dentalRestriction = {}, visionDetails = {}],
        { data: activeApplications }
      ] = data

      let dentalDetails = dentalStandard
      if (
        state.plansByType[DENTAL] &&
        state.brochures[state.plansByType[DENTAL][0]] &&
        state.brochures[state.plansByType[DENTAL][0]].includes('DENTALVI-071219CO.pdf') // cspell:disable-line
      ) {
        dentalDetails = dentalRestriction
      }

      const hasDentalActive = activeApplications.some(
        app => app.productType && app.productType.toLowerCase() === 'dental' && app.active
      )
      const hasVisionActive = activeApplications.some(
        app => app.productType && app.productType.toLowerCase() === 'vision' && app.active
      )

      store.update(
        {
          dentalDetails,
          visionDetails,
          hasDentalActive,
          hasVisionActive
        },
        true
      )
      return store.getState()
    }
  )
}

export default getAdditionalInfo
